// extracted by mini-css-extract-plugin
module.exports = {"iconStatus":"subscription_iconStatus__34Vt6","subscriptionSignUp":"subscription_subscriptionSignUp__LQDQR","root":"subscription_root__keA8H"};